import React from "react";
import { Card, CardBody, CardTitle, Table } from "reactstrap";

const formatDateTime = (value) => {
  if (!value) {
    return "-";
  }

  const asString = String(value);
  return asString.replace("T", " ");
};

const getAmountClass = (amount) => {
  const numericAmount = Number(amount);
  if (numericAmount > 0) return "text-success";
  if (numericAmount < 0) return "text-danger";
  return "";
};

const TransactionsPanel = ({ cashflows = [] }) => {
  return (
    <Card className="trades-panel app-widget-panel shadow-sm">
      <CardBody>
        <div className="trades-panel__header">
          <CardTitle tag="h5" className="trades-panel__title app-widget-title">
            Transactions
          </CardTitle>
        </div>
        <div className="trades-table-shell">
          <Table hover className="table-algo_color trades-table text-center mb-0">
            <thead>
              <tr>
                <th>Date</th>
                <th>Source</th>
                <th>Note</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {cashflows.length ? (
                cashflows.map((cashflow) => (
                  <tr key={cashflow.id} className="trades-table__row">
                    <td data-label="Date">{formatDateTime(cashflow.occurred_at)}</td>
                    <td data-label="Source">{cashflow.source || "-"}</td>
                    <td data-label="Note">{cashflow.note || "-"}</td>
                    <td data-label="Amount" className={getAmountClass(cashflow.amount)}>
                      £{Number(cashflow.amount || 0).toFixed(2)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" align="center" className="trades-table__empty">
                    <b>No Transactions Yet</b>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default TransactionsPanel;
